import {
  SET_RES_ID,
  SET_DRIVER_FIRST_NAME,
  SET_DRIVER_LAST_NAME,
  SET_DRIVER_CITIZENSHIP,
  SET_DRIVER_GENDER,
  SET_DRIVER_BIRTH_DATE,
  SET_CAR_LICENCE_PLATE,
  SET_TRAILER_LICENCE_PLATE,
  SET_CARGO_LENGTH,
  SET_CARGO_WEIGHT,
  SET_CONSIGNEE,
  SET_COUNTRY_FROM,
  SET_COUNTRY_TO,
  SET_CARGO_CONTENT,
  SET_DRIVER_DOCUMENT_TYPE,
  SET_DRIVER_EXPIRATION_DATE,
  SET_DRIVER_DOCUMENT_ISSUED_COUNTRY,
  SET_DRIVER_DOCUMENT_NUMBER,
  SET_DRIVER_INDEX,
} from '../constants/actions'

export const setReservationIdAction = (resId: string) => ({ type: SET_RES_ID, payload: resId })
export const setDriverFirstNameAction = (driverFirstName: string) => ({
  type: SET_DRIVER_FIRST_NAME,
  payload: driverFirstName,
})
export const setDriverLastNameAction = (driverLastName: string) => ({
  type: SET_DRIVER_LAST_NAME,
  payload: driverLastName,
})
export const setDriverCitizenshipCodeAction = (driverCitizenshipCode: string) => ({
  type: SET_DRIVER_CITIZENSHIP,
  payload: driverCitizenshipCode,
})
export const setDriverBirthDateAction = (birthDate: string) => ({
  type: SET_DRIVER_BIRTH_DATE,
  payload: birthDate,
})
export const setDriverGenderAction = (driverGender: string) => ({
  type: SET_DRIVER_GENDER,
  payload: driverGender,
})
export const setCarLicencePlateAction = (carLicencePlate: string) => ({
  type: SET_CAR_LICENCE_PLATE,
  payload: carLicencePlate,
})
export const setTrailerLicencePlateAction = (trailerLicencePlate: string) => ({
  type: SET_TRAILER_LICENCE_PLATE,
  payload: trailerLicencePlate,
})
export const setCargoLengthAction = (cargoLength: number) => ({ type: SET_CARGO_LENGTH, payload: cargoLength })
export const setCargoWeightAction = (cargoWeight: number) => ({ type: SET_CARGO_WEIGHT, payload: cargoWeight })
export const setCountryFromCodeAction = (countryFrom: string) => ({ type: SET_COUNTRY_FROM, payload: countryFrom })
export const setCountryToCodeAction = (countryTo: string) => ({ type: SET_COUNTRY_TO, payload: countryTo })
export const setCargoContentAction = (cargoContent: string) => ({ type: SET_CARGO_CONTENT, payload: cargoContent })
export const setConsigneeAction = (consignee: string) => ({ type: SET_CONSIGNEE, payload: consignee })

export const setDriverDocumentTypeAction = (driverDocumentType: string) => ({
  type: SET_DRIVER_DOCUMENT_TYPE,
  payload: driverDocumentType,
})
export const setDriverExpirationDateAction = (driverExpirationDate: string) => ({
  type: SET_DRIVER_EXPIRATION_DATE,
  payload: driverExpirationDate,
})
export const setDriverDocumentIssuedCountryAction = (driverDocumentIssuedCountry: string) => ({
  type: SET_DRIVER_DOCUMENT_ISSUED_COUNTRY,
  payload: driverDocumentIssuedCountry,
})
export const setDriverDocumentNumberAction = (driverDocumentNumber: string) => ({
  type: SET_DRIVER_DOCUMENT_NUMBER,
  payload: driverDocumentNumber,
})
export const setDriverIndexAction = (driverIndex: number) => ({
  type: SET_DRIVER_INDEX,
  payload: driverIndex,
})
